mutation UpdateGroup($input: EmailSequenceTemplateGroupUpdateInput!) {
    emailSequenceTemplateGroupUpdate(input: $input) {
        emailSequenceTemplateGroup {
            id
            name
        }
    }
}
